import { FC } from 'react'

const PortalTemplate: FC = () => {
  return <div>ポータルページ</div>
}

export default PortalTemplate
